<ng-container *transloco="let convert;">
  <div class="modal--action-list" role="dialog" aria-modal="true" aria-labelledby="make-active-modal-title"
       [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.markArrivedSucessModal.ariaLabelStatusUpdate')">

    <h1 class="modal__title" id="make-active-modal-title" tabindex="-1">
      <div ng-show="showCheckMark">
        <app-check-icon class="check-mark" fill="#0B8100"></app-check-icon>
        {{convert('sellModule.manageInventory.actionListModal.markArrivedSucessModal.textVehicleArrived')}}
      </div>
    </h1>
    <div class="modal__content">
      <div class="modal__body">
        <div>
          {{convert('sellModule.manageInventory.actionListModal.markArrivedSucessModal.textSuccesfullyMarked')}}
        </div>
        <div class="modal__actions">
          <button class="btn btn-primary me-md-2 mb-3 mb-md-0" [attr.aria-label]="convert('common.btnClose')" (click)="closeModal()">
            <span>{{convert('common.btnClose')}}</span>
          </button>
        </div>
      </div>
    </div>

    @if (configuration$()) {
      <button class="modal__close" data-dismiss="modal" [attr.aria-label]="convert('common.modalClose')" (click)="closeModal()"
              data-track-elem="icon" data-track-name="Close" data-track-trigger="close">
        <img src="../../../../../ui/assets/assets-{{ configuration$().tenantName }}/{{ configuration$().tenantName }}-close.svg"
             alt="{{convert('common.altCloseModelIcon')}}" />
      </button>
    }
  </div>
</ng-container>

